import { Routes, Route, Navigate } from 'react-router-dom';
import { FeatureGate } from '@shared/auth/FeatureGate';
import { useAuth } from '@shared/auth/AuthContext';
import CustomerLayout from './CustomerLayout';
import Creators from './Creators';
import Market, { LegacyBrowseRedirect } from './Market';
import Profile from './Profile';
import MyAnalytics from './MyAnalytics';
import Campaigns from './Campaigns';
import PriceAnalysis from './PriceAnalysis';
import ConnectBrand from './ConnectBrand';

// Browse hosts the 3 analytics tabs; visible if the user has ANY of them.
const BROWSE_FEATURES = ['an_social', 'an_digital', 'an_outdoor'];

export default function CustomerRoutes() {
  const { role, accessStatus, hasFeature } = useAuth();
  // Preview mode: brand not verified yet. Sections that need a verified brand lead to the
  // connect page instead of a "no access" wall.
  const preview = role !== 'admin' && accessStatus !== 'active';
  // Creators first: a business comes to find bloggers, not to read a market report.
  const home = hasFeature('an_social') ? 'creators' : hasFeature('an_my') ? 'my-analytics' : 'market';
  return (
    <Routes>
      <Route element={<CustomerLayout />}>
        <Route index element={<Navigate to={home} replace />} />
        <Route path="creators" element={<FeatureGate feature="an_social"><Creators /></FeatureGate>} />
        <Route path="market/*" element={<FeatureGate feature={BROWSE_FEATURES}><Market /></FeatureGate>} />
        <Route path="browse" element={<LegacyBrowseRedirect />} />
        <Route path="connect" element={<ConnectBrand />} />
        <Route path="campaigns" element={preview ? <Navigate to="/customer/connect" replace /> : <FeatureGate feature="act_request"><Campaigns /></FeatureGate>} />
        {/* legacy AI brief-intake flow retired: old /requests URL now redirects to the campaign board */}
        <Route path="requests" element={<Navigate to="/customer/campaigns" replace />} />
        <Route path="price-check" element={<FeatureGate feature="an_price"><PriceAnalysis /></FeatureGate>} />
        <Route path="my-analytics" element={preview ? <Navigate to="/customer/connect" replace /> : <FeatureGate feature="an_my"><MyAnalytics /></FeatureGate>} />
        <Route path="profile" element={<Profile />} />
        <Route path="*" element={<Navigate to={home} replace />} />
      </Route>
    </Routes>
  );
}
